import React from "react";

export function handle_error (error:any):number {
    if(error.response){
        return error.response.status
    }
    else {
        return -1
    }
}

type param_status = {
    status:number,
    message:string
}
export function handle_number_status(status:number,componente_ok?:JSX.Element, mensajes?:Array<param_status>){
    var mensaje = "";

    if(status === 200 && componente_ok){
        return componente_ok;
    }
    else if(status === 500){
        return (
            <React.Fragment>
                <div>Ha ocurrido un inconveniente, intentelo más tarde</div>
            </React.Fragment>
        )
    }
    else if(status ===401){
        var indice_busco:number = -1;
        if(mensajes){   
            indice_busco = mensajes.findIndex((valores)=> valores.status == 401) ;
            if(indice_busco != -1) { mensaje = mensajes[indice_busco].message}
        }
        
        return (
            <React.Fragment>
                <div>{mensaje !== ""? mensaje: "No está autorizado a realizar dicha"}</div>
            </React.Fragment>
        )
    }
}


